module.exports = __webpack_public_path__ + "static/media/8OLA28.44190904.jpg";